export const isClient = typeof localStorage != "undefined"
